module.exports = __webpack_public_path__ + "static/img/s3.04aa4476.png";